"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:6.5.4'] && _();
}
catch (e) { }
